var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.80942 19.7708C1.34643 20.0763 2.02043 20.0763 2.55748 19.7709L8.66604 16.2969C9.48535 15.8309 10.5136 15.8309 11.3329 16.2968L17.4424 19.771C17.9794 20.0764 18.6533 20.0763 19.1903 19.7709C20.2699 19.157 20.2699 17.6899 19.1903 17.0759L11.333 12.6077C10.5136 12.1417 9.48533 12.1418 8.666 12.6078L0.80954 17.0762C-0.269792 17.6901 -0.269857 19.1568 0.80942 19.7708Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.80942 13.6419C1.34643 13.9474 2.02043 13.9474 2.55748 13.642L8.66604 10.168C9.48535 9.702 10.5136 9.70197 11.3329 10.1679L17.4424 13.6421C17.9794 13.9474 18.6533 13.9474 19.1903 13.642C20.2699 13.0281 20.2699 11.561 19.1903 10.947L11.333 6.47878C10.5136 6.01283 9.48533 6.01287 8.666 6.47887L0.80954 10.9473C-0.269792 11.5612 -0.269857 13.0279 0.80942 13.6419Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.80942 7.51298C1.34643 7.81846 2.02043 7.8185 2.55748 7.51307L8.66604 4.03904C9.48535 3.57309 10.5136 3.57307 11.3329 4.03899L17.4424 7.51316C17.9794 7.81854 18.6533 7.81853 19.1903 7.51312C20.2699 6.89916 20.2699 5.43205 19.1903 4.81812L11.333 0.349879C10.5136 -0.116072 9.48533 -0.11604 8.666 0.34996L0.80954 4.81838C-0.269792 5.43225 -0.269857 6.89902 0.80942 7.51298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUp);
export default __webpack_public_path__ + "static/media/arrowsUp.4f96ea25bf16b72078f1fdcd33cbc616.svg";
export { ForwardRef as ReactComponent };